// src/blocks/richtext/richtext.tsx
import { PortableText } from "@portabletext/react";
import { jsx } from "react/jsx-runtime";
var components = {
  marks: {
    link: ({ children }) => {
      return children;
    },
    externalLink: ({ value, children }) => {
      const { newWindow, target } = value;
      return newWindow ? /* @__PURE__ */ jsx("a", { href: target, target: "_blank", rel: "noopener noreferrer", children }) : /* @__PURE__ */ jsx("a", { href: target, children });
    },
    internalLink: ({ value, children }) => {
      const { slug = {} } = value;
      const href = `/${slug?.current}`;
      return /* @__PURE__ */ jsx("a", { href, children });
    }
  }
};
var Richtext = ({ className, id, text = [] }) => {
  if (!text) return null;
  return /* @__PURE__ */ jsx("div", { className, id, children: /* @__PURE__ */ jsx(PortableText, { components, value: text }) });
};
var richtext_default = Richtext;

export {
  richtext_default
};
